import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CurierActivitiesService {
  private _isCurierAcceptanceSecondStep: boolean = false;
  private _isCurierDeliverySecondStep: boolean = false;
  private _deliveryPaddleWorkflow: boolean = true;
  private _isInitialStep: boolean = true;

  setCurierAcceptanceSecondStep(isCurierAcceptanceSecondStep: boolean): void{
    this._isCurierAcceptanceSecondStep = isCurierAcceptanceSecondStep;
  }
  get isCurierAcceptanceSecondStep(): boolean{
    return this._isCurierAcceptanceSecondStep;
  }

  setCurierDeliverySecondStep(isCurierDeliverySecondStep: boolean): void{
    this._isCurierDeliverySecondStep = isCurierDeliverySecondStep;
  }
  get isCurierDeliverySecondStep(): boolean{
    return this._isCurierDeliverySecondStep;
  }

  setCurierAcceptancePaddleWorfklow(isPaddleWorkflow: boolean): void{
    this._deliveryPaddleWorkflow = isPaddleWorkflow;
  }
  get isCurierAcceptancePaddleWorkflow(): boolean{
    return this._deliveryPaddleWorkflow;
  }

  setIsInitialStep(isInitialStep: boolean){
    this._isInitialStep = isInitialStep;
  }
  get isInitialStep(): boolean{
    return this._isInitialStep;
  }

}
